import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=337d390e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337d390e')) {
      api.createRecord('337d390e', component.options)
    } else {
      api.reload('337d390e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=337d390e&", function () {
      api.rerender('337d390e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4v7EtJXvl4QHn/JS/videoIframe.vue"
export default component.exports